type MicrotaskScheduler = (task: () => void) => void;

const promiseScheduler: MicrotaskScheduler = (task) => {
  Promise.resolve()
    .then(task)
    .catch(() => {
      // Intentionally ignore scheduler errors.
    });
};

const timeoutScheduler: MicrotaskScheduler = (task) => {
  setTimeout(task, 0);
};

const createScheduler = (): MicrotaskScheduler => {
  if (typeof queueMicrotask === 'function') {
    return queueMicrotask;
  }

  if (typeof Promise === 'function') {
    return promiseScheduler;
  }

  return timeoutScheduler;
};

export const scheduleMicrotask: MicrotaskScheduler = createScheduler();
export const deferToMicrotask = scheduleMicrotask;
